import { useCallback } from 'react';

import type { PaginationSort } from '@models';
import { normalizeTableSort } from '@utils/common';

import type { SortingState } from './types';

/**
 * Adapts a `PaginationSort` setter into a table's `onSortChange` handler.
 */
export const useTableSortChange = (setSort: (sort: PaginationSort) => void) =>
  useCallback(
    (sortedBy: SortingState) => setSort(normalizeTableSort(sortedBy)),
    [setSort],
  );
